import { ConfettiDark, ConfettiLight } from "@assets";
import { Flex, Text, useColorModeValue } from "@chakra-ui/react";
import Image from "next/image";

const _t = (key?: string) => key || "";

const CheckoutSuccessHeadings = ({
  heading = "Order Confirmed",
  title = "We are processing your order.",
  subtitle = "Once your payment is confirmed (if any), we will send you a confirmation email with your order details.",
  remark = "* Please note that processing crypto payments may take up to 30 minutes. We kindly ask for your patience during this time.",
}: {
  heading?: string;
  title?: string;
  subtitle?: string;
  remark?: string;
}) => (
  <Flex
    direction="column"
    justifyContent="center"
    alignItems="stretch"
    width="100%"
    padding={4}
  >
    <Flex
      direction="row"
      justifyContent="center"
      alignItems="center"
      gridGap={2}
    >
      <Text fontWeight="600" className="text-2xl font-medium dark:text-white">
        {_t(heading)}
      </Text>
      <Image
        src={useColorModeValue(ConfettiLight, ConfettiDark)}
        alt="confetti"
        width={60}
        height={60}
      />
    </Flex>
    <Text
      className="text-xl sm:text-2xl dark:text-white"
      fontWeight="600"
      marginTop={6}
      align="center"
    >
      {_t(title)}
    </Text>
    <Text
      className="text-sm sm:text-lg"
      align="center"
      color={useColorModeValue("", "neutral.100")}
      marginTop={2}
    >
      {_t(subtitle)}
    </Text>
    <Text
      className="text-sm sm:text-sm"
      align="center"
      color="neutral.500"
      marginTop={2}
    >
      {_t(remark)}
    </Text>
  </Flex>
);

export default CheckoutSuccessHeadings;
